import { useLocation } from "react-router-dom";
import { useFeatureFlagEnabled } from "posthog-js/react";

import { readLoginGrantState } from "helpers/login-grant";

import { authShellVariant, type AuthShellVariant } from "./auth-shell";

/** The chrome the current auth screen wears, for pages that adapt their
 * own controls to it. `AuthLayout` reads the same decision. */
export function useAuthShellVariant(): AuthShellVariant {
  const location = useLocation();
  const restyleFlag = useFeatureFlagEnabled("auth-restyle");
  const loginGrant = readLoginGrantState(location.state)?.loginGrant ?? null;
  return authShellVariant(restyleFlag, loginGrant);
}
